import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, HeadphonesIcon, ShieldAlertIcon } from 'lucide-react';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/pj89hPCrQ1HwjLHbQqmfWd/controla_la_ansiedad_2.png';
const products = [{
  icon: BookOpenIcon,
  title: 'Guía PDF "Camino a la Calma"',
  description: 'El manual completo con la ciencia y los pasos exactos para reprogramar tu respuesta al estrés. Tu hoja de ruta hacia la tranquilidad.'
}, {
  icon: HeadphonesIcon,
  title: 'Audiolibro Completo (5 Tracks)',
  description: 'Diseñado para escucharlo en momentos de tensión o antes de dormir para blindar tu mente. Tu compañero de calma siempre disponible.'
}, {
  icon: ShieldAlertIcon,
  title: 'Tarjeta S.O.S de Emergencia (7 Páginas)',
  description: 'Tu kit de primeros auxilios visual para llevar en el celular. Si sientes que pierdes el control, solo ábrela y sigue las instrucciones.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function WhatYouGetSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8" data-id="element-214">
      <div className="max-w-6xl mx-auto" data-id="element-215">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-12" data-id="element-216">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-brown mb-6" data-id="element-217">
            Todo lo que recibes hoy
          </h2>
          <p className="text-lg text-brown-light max-w-2xl mx-auto" data-id="element-218">
            Un sistema completo diseñado para darte alivio inmediato y
            herramientas a largo plazo.
          </p>
        </motion.div>

        <motion.div className="flex justify-center mb-16" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.7
      }} data-id="element-219">
          <img src={PRODUCT_IMAGE} alt="Pack completo: Guía Digital Camino a la Calma en tablet y Audiolibro en teléfono" className="w-full max-w-md rounded-2xl shadow-xl shadow-brown/10" data-id="element-220" />
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-221">
          {products.map((product, index) => {
          const Icon = product.icon;
          return <motion.div key={index} variants={cardVariants} className="bg-white rounded-3xl p-8 shadow-lg shadow-brown/5 border border-sage-light/50 flex flex-col items-center text-center hover:-translate-y-1 transition-transform duration-300" data-id="element-222">
                <div className="w-16 h-16 rounded-2xl bg-sage-light flex items-center justify-center text-sage-dark mb-6" data-id="element-223">
                  <Icon className="w-8 h-8" data-id="element-224" />
                </div>
                <h3 className="text-xl font-heading font-bold text-brown mb-4" data-id="element-225">
                  {product.title}
                </h3>
                <p className="text-brown-light leading-relaxed" data-id="element-226">
                  {product.description}
                </p>
              </motion.div>;
        })}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-sage-dark text-white rounded-2xl p-6 sm:p-8 max-w-2xl mx-auto text-center shadow-xl" data-id="element-227">
          <p className="text-lg mb-2 opacity-90" data-id="element-228">
            Valor total del sistema: <span className="line-through" data-id="element-229">$47</span>
          </p>
          <p className="text-3xl sm:text-4xl font-heading font-bold text-cream" data-id="element-230">
            🐣 Semana Santa: $8.50 (50% OFF)
          </p>
        </motion.div>
      </div>
    </section>;
}